function initHeaderOptions() {
  let windowWidth = window.innerWidth;
  const headerMenu = document.querySelector('.header__bottom');
  const buttons = document.querySelectorAll('[data-button]');

  // Refresh window size
  window.addEventListener('resize', () => {
    windowWidth = window.innerWidth;
  });

  if(buttons) {
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        // Burger button actions
        if(button.dataset.button === "header__burger") {
          headerMenu.classList.add('open');
          
        }
        // Close button actions
        if(button.dataset.button === "header__close") {
          headerMenu.classList.remove('open');
        }
        // Dropdown button actions
        if(button.dataset.button === "header__menu-dropdown" && windowWidth < 1023) {
          button.classList.toggle('open');
          if(!e.target.classList.contains('dropdown-list__childlink')) {
            const dropdown = button.querySelector('[data-dropdown]');
            dropdown.classList.toggle('open');
          }
        }
      });
    });
  }
}

function initHeaderScrolling() {
  const announcementBar = document.querySelector('.announcement-bar-section');
  const header = document.querySelector('.section-header');

  if (announcementBar && header) {
    const headerHeight = header.offsetHeight;
    let lastScrollPosition = window.scrollY;

    window.addEventListener('scroll', () => {
      const currentScrollPosition = window.scrollY;

      if (currentScrollPosition > headerHeight / 3) {
        if (currentScrollPosition > lastScrollPosition) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      } else {
        header.classList.remove('scrolled');
      }

      lastScrollPosition = currentScrollPosition;
    });
  }
}

window.addEventListener('DOMContentLoaded', () => {
  initHeaderOptions();
  initHeaderScrolling();
});